<template>
  <v-dialog v-model="value" max-width="70vw">
    <v-card :loading="loading" :disabled="loading">
      <v-card-title class="justify-center">
          <span class="text-h5 sp">{{ $t('campus_group_admins.create') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.firstname"
                  :label="$t('campus_group_admins.firstname')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.lastname"
                  :label="$t('campus_group_admins.lastname')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.lastname2nd"
                  :label="$t('campus_group_admins.lastname2nd')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.email"
                  :label="$t('campus_group_admins.email')"
                  :rules="[rules.required, rules.email]"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.dni"
                  :label="$t('campus_group_admins.dni')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.birthDate"
                      :label="$t('campus_group_admins.birth_date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.birthDate"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="form.campus_group_id"
                  :items="campusGroups"
                  item-text="name"
                  item-value="id"
                  :label="$t('campus_group_admins.campus_group')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn color="deep-purple" text @click="save" :disabled="!valid">
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import campusGroupAdminService from '../../../services/campusGroupAdmin.service';
import snackbarMixin from '../../../mixins/snackbar';

export default {
  name: 'CreateCampusGroupAdminModal',
  components: {
  },
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({
    loading: false,
    valid: false,
    dateMenu: false,
    campusGroups: [],
    form: {
      firstname: '',
      lastname: '',
      lastname2nd: '',
      email: '',
      dni: '',
      birthDate: '',
      campus_group_id: null,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
  }),
  mixins: [snackbarMixin],
  computed: {
  },
  mounted() {
    this.loadCampusGroups();
  },
  watch: {
  },
  methods: {
    async loadCampusGroups() {
      try {
        const response = await campusGroupAdminService.getAvailableCampusGroups();
        this.campusGroups = response.data.data || response.data || [];
      } catch (error) {
        this.campusGroups = [];
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await campusGroupAdminService.createCampusGroupAdmin(this.form);
          this.$emit('onSave');
          this.resetForm();
        } catch (error) {
          const errorMessage = this.getErrorMessage(error);
          this.snackbarError(errorMessage);
        } finally {
          this.loading = false;
        }
      }
    },
    close() {
      this.resetForm();
      this.$emit('onCancel');
    },
    resetForm() {
      this.form = {
        firstname: '',
        lastname: '',
        lastname2nd: '',
        email: '',
        dni: '',
        birthDate: '',
        campus_group_id: null,
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    getErrorMessage(error) {
      if (error.response && error.response.data) {
        const { message, title } = error.response.data;
        return message || title || 'Error al crear administrador de grupo de sede';
      }
      return error.message || 'Error al crear administrador de grupo de sede';
    },
  },
};
</script>

<style scoped>
span.sp{
    font-family: "Space Grotesk" !important;
}
</style>
